import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Subtitle2 } from '@xcomp/xcomp-design-library';
import AddIllustration from '@xcomp/xcomp-design-library/dist/illustrations/AddIllustration';

const Layout = styled.div`
  width: 100%;
  min-height: 400px;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
`;

const Message = styled(Subtitle2)`
  width: 100%;
  text-align: center;
`;

const NoItemsMessage = ({ message }) => {
  return (
    <Layout>
      <AddIllustration />
      <Message>{message}</Message>
    </Layout>
  );
};

NoItemsMessage.propTypes = {
  message: PropTypes.string
};

NoItemsMessage.defaultProps = {
  message: ''
};
export default NoItemsMessage;
